import { getNotificationComments } from "../../services/notification";
import { getUserData } from "../../services/users";

export const getCommentsData = async (
  start,
  stop,
  keywordFilter,
  containerObjectIdList,
) => {
  let commentsList = [];
  const { token, ...user } = JSON.parse(localStorage.getItem("user"));

  const userData = await getUserData(user._id);
  const authorizedAddresses = userData.data.user.authorizedAddresses;

  const containerIdsParam =
    containerObjectIdList?.length > 0
      ? containerObjectIdList
          .map((id) => id?.toString?.() ?? String(id))
          .join(",")
      : undefined;

  const response = await getNotificationComments({
    start,
    stop,
    keywordFilter,
    ...(containerIdsParam && { containerIds: containerIdsParam }),
  });

  if (Array.isArray(response?.data) && response.data.length > 0) {
    for (const data of response.data) {
      const containerId = data?.container?._id;
      const addressId = data?.container?.addressId;

      const passesContainerFilter =
        !containerObjectIdList?.length ||
        !containerId ||
        containerObjectIdList.some(
          (id) =>
            (id?.toString?.() ?? String(id)) ===
            (containerId?.toString?.() ?? String(containerId)),
        );

      const isAuthorized =
        !Array.isArray(authorizedAddresses) ||
        authorizedAddresses.length === 0 ||
        (addressId && authorizedAddresses.includes(addressId));

      if (
        passesContainerFilter &&
        isAuthorized &&
        Array.isArray(data?.comments) &&
        data.comments.length > 0
      ) {
        commentsList.push(
          ...data.comments.map((item) => ({
            ...item,
            wasteName: data?.container?.wasteName,
            positioning: data?.container?.positioning,
          })),
        );
      }
    }
  }

  return commentsList;
};
